import { IModel } from './model';
import { PlayerSettings } from './player.settings';

export enum PlayerType {
  Local,
  Spotify,
}

export interface IPlayer extends IModel {
  name: string;
  email: string;
  type: PlayerType;
}

export interface IPlayerWithSettings extends IPlayer {
  settings: PlayerSettings;
}
